// extracted by mini-css-extract-plugin
export default {"toggle":"styles_toggle__OBjrE","icon_left":"styles_icon_left__iVhgk","icon_right":"styles_icon_right__I2fct","thumb":"styles_thumb__op--W","dark":"styles_dark__Rl3xo"};